import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { isAndroid, isIOS } from 'react-device-detect';
import { createGuestNewLandingUsage } from '../reducers/newLandingReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchange, faLaptop, faLock, faKey, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { SignUp, finishReg, Processing } from 'cloak-file-sdk-web';
import '../styles/landing.css';

class NewLandingPageSignup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { redirectToLogin: false };
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    const url = new URL(window.location.href);
    const email = url.searchParams.get('email');
    const campaignId = url.searchParams.get('campaign_id');
    this.props.dispatch(createGuestNewLandingUsage(email, campaignId));

    document.body.style.backgroundImage = "url('/cloak/public/img/cloak-bkg-l.jpeg')";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundPosition = "center";
  }

  componentWillUnmount() {
  }

  onClick() {
    this.props.dispatch(finishReg(true));
    this.setState({ redirectToLogin: true });
  }

  render() {
    const { intl, status, reg_error, regInProcess } = this.props;
    const { redirectToLogin } = this.state;

    if (isAndroid) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.cloakapps.cloak";
        return null;
    } else if (isIOS) {
        window.location.href = "https://apps.apple.com/us/app/cloak-encrypt/id1495943745";
        return null;
    }

    if (redirectToLogin) return <Navigate to="/cloak/login" />;

    const features = [
      { icon: faExchange, title: 'Password-Free Sharing',     desc: 'Encrypt & send files without juggling passwords.' },
      { icon: faLaptop,   title: (
        <>
          Browser and{' '}
          <span
            onClick={() => {
              const userAgent = navigator.userAgent || navigator.vendor || window.opera;
              const isAndroid = /android/i.test(userAgent);
              const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
              if (isAndroid) {
                window.location.href = 'https://play.google.com/store/apps/details?id=com.cloakapps.cloak';
              } else if (isIOS) {
                window.location.href = 'https://apps.apple.com/us/app/cloak-encrypt/id1495943745';
              } else {
                document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
          >
            Mobile-Only{' '}
          </span>Encryption
        </>
      ),   desc: 'All file crypto runs locally — not at our servers.' },
      { icon: faUserShield, title: 'User Key Control',     desc: (
        <>
          Option to self-manage your asymmetric crypto keys. Just uncheck "Save your key with Cloak"
          during{' '}
          <span
            onClick={() =>
              document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })
            }
            style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
          >
            sign-up
          </span>.
        </>
      ), },
      { icon: faLock,     title: 'Real-Time Access Control',  desc: 'Approve or deny requests instantly from any device.' },
      { icon: faKey,      title: 'Enterprise Key Management', desc: (
        <>
          Use <a href="https://www.cloakapps.com/cloak/newgwy" target="_blank" rel="noopener noreferrer">Cloak Gateway</a> for company user key control.
        </>
      ) },
    ];

    return (
      <div className="landing-container">

        {/* Hero */}
        <section className="hero">
          <h1>Encrypt. Share. Control.</h1>
          <p className="subtitle">
            Client-side AES-256 &amp; Asymmetric Key encryption in your browser — Enterprise File Protection for Everyone.
          </p>
          <div className="hero-ctas">
            <button
              className="btn-primary"
              onClick={() => document.getElementById('signup-section').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Started — It’s Free
            </button>
            <button
              className="btn-secondary"
              onClick={() => window.location.href = 'https://www.cloakapps.com/cloak.html'}
            >
              Learn More
            </button>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="benefits-section">
          <h2>Why use Cloak?</h2>
          <div className="benefits-grid">
            {features.map(({ icon, title, desc }, idx) => (
              <div key={idx} className="card">
                <FontAwesomeIcon icon={icon} size="2x" className="card-icon" />
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Signup at bottom */}
        <section id="signup-section" className="signup-section">
          <h2>Join over 40k professionals securing their files today!</h2>
          <div className="signup-card">
            <Processing
              show={regInProcess}
              processing={regInProcess && status === null && reg_error === null}
              message={
                regInProcess && status === 200 && new URL(window.location.href).searchParams.get('code')
                  ? intl.formatMessage({ id: 'signUp.guestSuccessMessage' })
                  : regInProcess && status === null && reg_error === null
                    ? intl.formatMessage({ id: 'signUp.registering' })
                    : regInProcess && status === 200
                      ? intl.formatMessage({ id: 'signUp.verifyMessage' })
                      : ''
              }
            >
              {regInProcess && status === 200 && (
                <button className="btn-primary" onClick={this.onClick}>
                  {intl.formatMessage({ id: 'signUp.ok' })}
                </button>
              )}
            </Processing>

            <SignUp
              emailLabel={intl.formatMessage({ id: 'signUp.email' })}
              pwdLabel={intl.formatMessage({ id: 'signUp.password' })}
              cnfrmPwdLabel={intl.formatMessage({ id: 'signUp.confirmPwd' })}
              actionTitle={intl.formatMessage({ id: 'signUp.title' })}
              email={new URL(window.location.href).searchParams.get('email')}
              code={new URL(window.location.href).searchParams.get('code')}
              campaignId={new URL(window.location.href).searchParams.get('campaign_id')}
            />
          </div>
        </section>

      </div>
    );
  }
}

NewLandingPageSignup.propTypes = {
  status:       PropTypes.number,
  reg_error:    PropTypes.string,
  regInProcess: PropTypes.bool,
  dispatch:     PropTypes.func.isRequired,
  intl:         PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  status:       state.reg.reg_status,
  reg_error:    state.reg.reg_error,
  regInProcess: state.reg.regInProcess,
});

export default connect(mapStateToProps)(injectIntl(NewLandingPageSignup));